import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { get } from '@cullylarson/f';
import { routeToTop } from '@@client/lib/nextjs';
import { preventDefault } from '@@client/lib/events';
var styleNav = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "269126661",
    children: [".jsx-269126661 input[type='text']{border:0;-webkit-box-shadow:inset 0 0 3px 0 white;box-shadow:inset 0 0 3px 0 white;background:rgba(216,216,216,0.4);color:white;}", ".jsx-269126661 input[type='text']::-webkit-input-placeholder{color:white;}", ".jsx-269126661 input[type='text']::-moz-placeholder{color:white;}", ".jsx-269126661 input[type='text']:-ms-input-placeholder{color:white;}", ".jsx-269126661 input[type='text']::-ms-input-placeholder{color:white;}", ".jsx-269126661 input[type='text']::-webkit-input-placeholder{color:white;}", ".jsx-269126661 input[type='text']::-moz-placeholder{color:white;}", ".jsx-269126661 input[type='text']:-ms-input-placeholder{color:white;}", ".jsx-269126661 input[type='text']::placeholder{color:white;}"]
  }),
  className: "jsx-269126661"
};
export default function NaturalSearchForm(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Search for a part' : _ref$label,
      _ref$action = _ref.action,
      action = _ref$action === void 0 ? '/parts' : _ref$action,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? null : _ref$id,
      _ref$styleDef = _ref.styleDef,
      styleDef = _ref$styleDef === void 0 ? styleNav : _ref$styleDef,
      children = _ref.children,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit;
  var router = useRouter();
  var q = get('q', '', router.query);

  var _useState = useState(q || ''),
      query = _useState[0],
      setQuery = _useState[1];

  useEffect(function () {
    var onRouteChangeComplete = function onRouteChangeComplete(url) {
      var bits = url.split('?');
      if (!bits[1]) return;
      var urlParams = new URLSearchParams(bits[1]);
      setQuery(urlParams.get('q') || '');
    };

    router.events.on('beforeHistoryChange', onRouteChangeComplete);
    return function () {
      return router.events.off('beforeHistoryChange', onRouteChangeComplete);
    };
  }, []);

  var handleParam = function handleParam(setValue) {
    return function (e) {
      return e && e.target ? setValue(e.target.value) : setValue(e);
    };
  };

  var handleSubmit = preventDefault(function () {
    onSubmit();
    routeToTop(router, {
      pathname: action,
      query: {
        q: query
      }
    });
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit,
      className: "jsx-3664012089" + " " + ((styleDef === null || styleDef === void 0 ? void 0 : styleDef.className) || ""),
      children: [/*#__PURE__*/_jsx("input", {
        id: id,
        type: "text",
        name: "q",
        value: query,
        onChange: handleParam(setQuery),
        placeholder: label,
        "aria-label": label,
        disabled: disabled ? 'disabled' : '',
        className: "jsx-3664012089"
      }), /*#__PURE__*/_jsx("button", {
        "aria-label": "Search",
        type: "submit",
        className: "jsx-3664012089" + " " + 'submit-icon m--no-btn'
      }), children]
    }), styleDef === null || styleDef === void 0 ? void 0 : styleDef.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3664012089",
      children: ["form.jsx-3664012089{position:relative;margin:10px 15px;}", "form.jsx-3664012089 input[type='text'].jsx-3664012089{padding:7px 33px 7px 8px;}", "button.submit-icon.jsx-3664012089{position:absolute;top:0;right:0;cursor:pointer;width:33px;height:100%;background:transparent url('/images/icons/icon-search.svg') no-repeat center center;background-size:17px 17px;}"]
    })]
  });
}